import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de9b0a15bd30af/app/[locale]/faq/FAQPageClient.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de9b0a15bd30af/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustBadges"] */ "/tmp/8de9b0a15bd30af/components/sections/TrustBadges.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de9b0a15bd30af/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9b0a15bd30af/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9b0a15bd30af/app/[locale]/faq/FAQPage.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9b0a15bd30af/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de9b0a15bd30af/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
